import { render, staticRenderFns } from "./calculator.vue?vue&type=template&id=d640052a&scoped=true&"
import script from "./calculator.vue?vue&type=script&lang=js&"
export * from "./calculator.vue?vue&type=script&lang=js&"
import style0 from "./calculator.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./calculator.vue?vue&type=style&index=1&id=d640052a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d640052a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/ctg-code/qihuibao-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VFlex,VForm,VLayout,VSelect,VTextField})
